export const AssetsPanel = ({ assetsTable, flatAssets, onSubCount, onTotalCount }) => (
  <div className="flex items-start pl-2">
    <span className="mt-7 mr-2 flex-shrink-0">
      <div className="w-4 h-4 rounded-full !border !border-black bg-red-500" />
    </span>
    <div className="w-[200px] flex-shrink-0">
      <div className="flex flex-col ">
        <div className="bg-[#003d7a] text-center text-white p-1.5 text-[8px] font-bold !border-b-2 !border-black">
          {assetsTable.title}
        </div>
        <div className="bg-[#ed1a1a] text-center text-white p-1 text-[7px] font-bold !border-b-2 !border-black">
          ASSETS DEPLOYED 
        </div>
        <table className="w-full  text-[6px] leading-tight">
          <tbody>
            {flatAssets.map((asset, idx) =>
              asset.isCategory ? (
                <tr key={idx}>
                  <td className="bg-[#003d7a] text-white font-bold p-0.5 !border-b !border-r !border-l  !border-black w-[60%]">
                    <span className="px-0.5 text-[9px]">{asset.name}</span>
                  </td>
                  <td className="p-0.5 text-center font-bold !border-b !border-r !border-l  !border-black w-[13%]">
                    <input type="text" value={asset.subCount || ''} disabled onChange={e => onSubCount(idx, e.target.value)}
                      className="w-full text-[9px] !border-0 bg-transparent text-white text-center outline-none px-0.5" />
                  </td>
                  <td className="p-0.5 text-center font-bold !border-b !border-r !border-l  !border-black w-[13%] bg-white">
                    <input type="text" value={asset.totalCount || ''} onChange={e => onTotalCount(idx, e.target.value)}
                      className="w-full text-[9px] !border-0 bg-transparent text-center outline-none px-0.5" />
                  </td>
                </tr>
              ) : (
                <tr key={idx}>
                  <td className="p-0.5 text-[9px] !border-b !border-r !border-l !border-black"><span className="px-0.5">{asset.name}</span></td>
                  <td className="p-0.5 text-center !border-b !border-r !border-black">
                    <input type="text" value={asset.subCount || ''} onChange={e => onSubCount(idx, e.target.value)}
                      className="w-full text-[9px] !border-0 bg-transparent text-center outline-none px-0.5" />
                  </td>
                  <td className="p-0.5 text-center !border-b !border-r !border-l !border-black">
                    <input disabled type="text" value={asset.totalCount || ''} onChange={e => onTotalCount(idx, e.target.value)}
                      className="w-full text-[9px] !border-0 bg-transparent text-center outline-none px-0.5" />
                  </td>
                </tr>
              )
            )}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);